<template>
  <div id="app">
    <el-container v-if="isAuthtorized() && $route.fullPath !== '/login'" style="height: 100vh;">
      <el-header v-if="isMobile" class="main-header" style="flex: 0 0 55px;">
        <div class="navbar-toggler">
          <i v-if="isOpen" class="header-icon el-icon-s-fold" @click="isOpenMenu('2')"></i>
          <i v-else class="header-icon el-icon-s-unfold" @click="isOpenMenu('4')"></i>
        </div>
        <div class="logo">
          <a href="/">
            <img alt="" src="@/assets/logo.png" style="width: 100px">
          </a>
        </div>
        <!--<div class="user-info">
          <span @click="logout('/login')" style="cursor: pointer">Выход</span>
        </div>-->
      </el-header>
      <MenuTop v-if="isOpen" />
      <el-container>
        <!--<el-aside v-if="isOpen" width="260px">
          <Menu/>
        </el-aside>-->
        <el-main class="container-fluid">
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
    <router-view v-else/>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import MenuTop from '@/components/MenuTop'

export default {
  components: {
    //Menu,
    MenuTop
  },
  data() {
    return {
      isOpen: false,
      isMobile: (window.innerWidth >= 800) ? false : true,
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    isOpenMenu(trigg) {
      localStorage.isOpenMenu = trigg;
      this.isOpen = (localStorage.isOpenMenu == '4') ? true : false;
      if (window.innerWidth >= 800) {
        this.isOpen = true;
      }
    },
    isAuthtorized() {
      var vari = true
      if (localStorage.access_token == null) {
        vari = false
      }
      return vari;
    },
  },
  mounted() {
    localStorage.isOpenMenu = '2';
    this.isOpenMenu(localStorage.isOpenMenu);
  },
}
</script>

<style lang="scss">
@import "./assets/css/reset.css";

// Требуемое
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap/scss/bootstrap-grid";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.el-upload--picture-card {
  max-width: 300px;
  max-height: 261px;
  //width: auto !important;
  //height: auto !important;
  border: none !important;
}

.main-header {
  border-bottom: 1px solid #c8ced3;
  background-color: #ffffff;
  position: fixed;
  width: 100%;
  z-index: 99;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 155px;
  height: 55px;
  padding: 0;
  margin-right: 0;
  background-color: transparent;
}

.el-main {
  margin-top: 60px;
}

.main {
  padding: 0 30px;
  position: relative;

  h3 {
    text-align: left;
  }

  &-content {
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid #c8ced3;
    border-radius: .25rem;
    padding: 1.25rem;
    text-align: left;
    position: relative;
  }
}

.sub-title {
  text-align: left;
}

.navbar-toggler {
  min-width: 50px;
  padding: .25rem 0;
  cursor: pointer;
  font-size: 30px;
  color: #757474;
}

.user-info {
  margin-left: auto;
}

.edit-rate {
  .el-rate__icon {
    font-size: 30px;
  }
}

.pagination {
  text-align: center;
}

.el-upload {
  width: 300px !important;
  height: 261px !important;
}

.avatar-uploader-icon {
  width: 300px !important;
  height: 261px !important;
  line-height: 261px !important;
}

.el-form-item__label {
  font-size: 12px !important;
}

.el-form-item__label {
  padding: 0 !important;
  margin-bottom: 0 !important;
}

.table-size {
  position: absolute;
  right: 20px;
  margin: 5px 0;
}

.el-table .cell {
  word-break: break-word !important;
}

.el-pagination {
  padding: 10px 10px !important;
}
.el-upload {
  display: block !important;
  width: auto !important;
  height: auto !important;
}
.el-upload-dragger {
  width: auto !important;
  height: auto !important;
}
</style>
